<template>
	<v-footer app style="background-color: rgba(21, 102, 124, 0.9); margin: 0px 0px 0px 2px" color="lighten-1" padless>
      <v-row justify="center" no-gutters>
			<v-col  class=" lighten-2 py-4 text-center white--text" cols="12">
          <strong>WESTAT</strong> - {{ new Date().getFullYear() }}
        </v-col>
      </v-row>
    </v-footer>
</template>

<script>
import { commonService } from "@/services/common.service.js";

export default ({
	name: "Footer",
	data: () => ({
	})
})
</script>
